import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import api from '../../../services/api'
import buildQuery from 'odata-query'
import * as GalleryUIHelper from '../GalleryUIHelper'
import _ from 'lodash'

const ICONS_URL = '/imagestore'

// Default value
const initialIconsState = {
    totalCount: 0,
    entities: null,
    isUploading: false,
    iconSelected: null,
    error: null,
    loading: 'idle',
    querySelector: {
        search: '',
        page: 1,
        type: 0,
        itemsPerRow: 12
    }
}

// Carrega a lista de imagens
export const fetchGallery = createAsyncThunk(
    'icons/fetchGallery',
    async (userData, { rejectWithValue, getState } ) => {
        const { querySelector } = getState().icons
        const query = {
            filter: {
                type: _.find(GalleryUIHelper.IMAGE_TYPE, (el) => el.id === querySelector.type ).odata
            },
            count: true,
            top: querySelector.itemsPerRow,
            skip: (querySelector.page - 1) * querySelector.itemsPerRow,
            orderBy: ['Name asc']
        }

        // Só adiciona na filtragem se não for nulo
        if ( ! _.isNull( querySelector.search ) && querySelector.search !== '' ) {
            query.filter.name = {
                contains: querySelector.search,
            };
        }

        try {
            const response = await api.get(`${ICONS_URL}/odata/${buildQuery(query)}`);
            return {
                entities: response.data.value,
                count: response.data['_count'],
            };
        } catch (err) {
            rejectWithValue(err.response.data);
        }
    }
);

export const iconsSlice = createSlice({
    name: 'icons',
    initialState: initialIconsState,
    reducers: {
        iconsFetched: (state, action) => {
            const { entities, totalCount } = action.payload
            state.entities = entities;
            state.totalCount = totalCount;
        },
        iconIsUpload: (state, action ) => {
            state.isUploading = true
        },
        //
        // Inicio da refatoração
        //
        // vá para a pagina
        gotoPage: ( state, action ) => {
            state.querySelector.page = action.payload;
        },
        
        // Muda o tipo da galeria e reseta todos os valores
        changeType: (state, action ) => {
            state.querySelector.page = initialIconsState.querySelector.page
            state.querySelector.itemsPerRow = initialIconsState.querySelector.itemsPerRow
            state.querySelector.search = initialIconsState.querySelector.search
            state.querySelector.type = action.payload
        },
        // Pesquise por
        searchFor: ( state, action ) => {
            // reseta valores
            state.querySelector.page = initialIconsState.querySelector.page; // reseta paginação
            
            state.querySelector.search = action.payload;
        }
    },
    extraReducers: (build) => {
        // Quando a ação estiver pendente
        build.addCase(fetchGallery.pending, (state, action) => {
            if ( state.loading === 'idle' ) {
                state.loading = 'carregando'
                state.error = null
            }
        })
        // Quando a ação estiver completa
        .addCase(fetchGallery.fulfilled, (state, action) => {
            if ( state.loading === 'carregando' ) {
                state.loading = 'idle'
                state.entities = action.payload.entities
                state.totalCount = action.payload.count
            }
        })
        // Quando a ação for rejeitada
        .addCase(fetchGallery.rejected, (state, action ) => {
            if ( state.loading === 'carregando' ) {
                state.loading = 'idle'
                state.error = action.error.message
            }
        })
    }
})

// Export redux actions
export const { gotoPage, changeType, searchFor } = iconsSlice.actions;